/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AccountService } from './services/account.service';
import { AgencyService } from './services/agency.service';
import { AgencyBarcodeService } from './services/agency-barcode.service';
import { AgencyContactService } from './services/agency-contact.service';
import { AgencyInquiryService } from './services/agency-inquiry.service';
import { DashboardService } from './services/dashboard.service';
import { EmployeeService } from './services/employee.service';
import { FoodSourceService } from './services/food-source.service';
import { KioskService } from './services/kiosk.service';
import { PasswordResetService } from './services/password-reset.service';
import { ProductCategoryService } from './services/product-category.service';
import { ReferenceNumberService } from './services/reference-number.service';
import { TransactionService } from './services/transaction.service';
import { TransactionTypeService } from './services/transaction-type.service';
import { VersionService } from './services/version.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AccountService,
    AgencyService,
    AgencyBarcodeService,
    AgencyContactService,
    AgencyInquiryService,
    DashboardService,
    EmployeeService,
    FoodSourceService,
    KioskService,
    PasswordResetService,
    ProductCategoryService,
    ReferenceNumberService,
    TransactionService,
    TransactionTypeService,
    VersionService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
